<template>
  <div class="uploadInvoice">
    <el-dialog
      title="上传发票"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="上传发票" prop="invoiceUrl">
            <el-upload
              ref="upload"
              :limit="1"
              :format="['pdf']"
              accept=".pdf, .PDF"
              :action="uploadHost"
              :data="uploadData"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :clearFiles="clearFiles"
              :file-list="file_list"
              :on-error="handleFormatError"
            >
              <el-button slot="trigger" size="small" type="primary"
                >本地文件</el-button
              >
              <div slot="tip" class="el-upload__tip">支持.PDF格式文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import { uploadInvoice } from "@/api/orderAdmin/invoiceList.js";
export default {
  data() {
    return {
      max: 1,
      value: "",
      text: "",
      showModal: false,
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      file_list: [],
      dialogVisible: false,
      formInline: {
        invoiceUrl: "",
      },
      rules: {
        invoiceUrl: [{ required: true, message: "请上传发票附件" }],
      },
      invoiceId: "",
    };
  },
  watch: {
    "formInline.invoiceUrl": {
      handler(to) {
        if (to) {
          this.$nextTick(()=>{
            this.$refs.formInline.clearValidate("invoiceUrl");
          })
        }
      },
      deep: true,
    },
  },
  methods: {
    // 初始化
    init(payload) {
      this.formInline = {
        invoiceUrl: "",
      };
      this.invoiceId = payload.id;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.file_list = []
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          uploadInvoice({
            ...this.formInline,
            invoiceId: this.invoiceId,
          }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.handleClose()
            }
          });
        }
      });
    },
    beforeUpload(file) {
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data;
            this.formInline.invoiceUrl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
            this.$emit("input", res.data);
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
      this.file_list = [];
    },
    handleRemove() {
      this.formInline.invoiceUrl = "";
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
    },
  },
};
</script>